import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { context } from '../../context/store';
import { FaInfoCircle } from 'react-icons/fa';
import Name2 from '../../Utils/Svg/Name2';
import Svg from '../../Utils/Svg/Svg';
import './About.scss';
const About = (props) => {
  const [divHeight, setDivHeight] = useState(0);
  const [difHeight, setDifHeight] = useState();
  const [scrollY, setScrollY] = useState(0);
  const [fade, setFade] = useState(false);
  const [translate, setTranslate] = useState(0);

  const ref = useRef();
  const { dispatch } = useContext(context);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      setDivHeight(ref.current.offsetHeight);
      setDifHeight(divHeight - scrollY);

      dispatch({ type: 'ABOUT_HEIGHT', aboutHeight: divHeight });
      if (window.scrollY > 0 && window.scrollY < divHeight) {
        setScrollY(window.scrollY);
      } else {
        setScrollY(0);
      }
      setTranslate((10 * scrollY) / 100);

      if (difHeight <= divHeight / 2) {
        setFade(true);
      } else {
        setFade(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [divHeight, scrollY, difHeight, dispatch]);

  return (
    <div
      ref={ref}
      className={`border-b-2 border-teal-400   h-full   min-h-screen flex flex-col items-center justify-center bg-slate-900`}
    >
      <div
        className={`${
          fade && 'opacity-50'
        } transition-opacity duration-[.2s] ease-in-out flex flex-col gap-3 `}
      >
        <h1
          style={{
            transform: `translate(${translate}%)`,
            transition: `all .2s  ease-in-out`,
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            MozBackfaceVisibility: 'hidden',
            scrollBehavior: 'smooth',
          }}
          className=" md:px-7 px-1 flex flex-col sm:gap-7 items-center justify-center"
        >
          <Name2 />
          <Svg />
        </h1>
        <p
          style={{
            transform: `translate(-${translate}%)`,
            transition: `transform .2s  ease-in-out`,
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            MozBackfaceVisibility: 'hidden',
          }}
          className="text-teal-200 tracking-wide  text-center font-semibold text-lg lg:text-xl lg:px-44 brightness-125"
        >
          I am a Front end web developer, who loves writing bugless clean code
          and delivers exactly what you need. Your imagination can go wild , so
          do mine. I don't like compromising with the feature or the necessity.
          I believe that, in the case of web development, anything that can be
          imagined, can be developed.
        </p>
        <div className="w-full flex justify-center">
          <NavLink to="/about">
            <button
              style={{
                transform: `translateY(${translate}%)`,
                transition: `all .2s  ease-in-out`,
                backfaceVisibility: 'hidden',
              }}
              className="aboutbutton before:text-teal-300  w-36 h-14 before:content-['More_About_Me'] before:brightness-110 hover:before:content-[''] group p-[10px] relative cursor-pointer  after:content-[''] 
            after:absolute after:bg-gradient-to-tr after:from-teal-300 
            after:to-teal-400 after:w-0 after:h-full
        after:hover:w-full   after:right-0 after:bottom-0
        z-50 after:-z-50  after:transition-[width,0.4s,ease-in-out]
           border-4 border-double  border-teal-400 rounded-md text-teal-400
           font-semibold mt-7"
            >
              <p>
                <FaInfoCircle
                  className="group-hover:w-full text-slate-900 
                 w-0 absolute group-hover:text-4xl "
                />
              </p>
            </button>
          </NavLink>
        </div>
      </div>
      {/* <div class="mt-[40px] box-border">
        <div className={`relative  ${opener ? ' carWreck' : 'car'}`}>
          <img src={car} className="z-20" alt="car" />
          <img
            src={html}
            className="absolute  top-72 left-[170px] w-9 h-9 rounded-full border-2 border-teal-400 animate-reverse-spin"
            alt="html"
          />
          <div className="bg-black w-[48px] h-4 top-72 left-[164px] shadow-md shadow-black rounded-t-full  absolute " />
        </div>
      </div> */}
    </div>
  );
};

export default About;
